import styled from "@emotion/styled";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
export const StyledCategoryPageContent = styled.div`
  .template-list-wrapper {
    margin: 52px 0 100px 0;
  }

  .mobile-navigation-wrapper {
    display: none;
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .mobile-navigation-wrapper {
      display: flex;
      width: 100%;
      margin-top: 24px;
    }
  }
`;
